import { makeStyles } from "@material-ui/core/styles";

export const useStyles = makeStyles((theme) => ({
  masonry: {
    columnGap: 16,
    columnCount: 3,
    [theme.breakpoints.down("sm")]: { columnCount: 2 },
    [theme.breakpoints.down("xs")]: { columnCount: 1 },
  },
  item: {
    position: "relative",
    breakInside: "avoid",
    marginBottom: 16,
    borderRadius: 12,
    overflow: "hidden",
    cursor: "pointer",
    boxShadow: "0 4px 14px rgba(0,0,0,0.12)",
    transition: "transform 0.25s ease, box-shadow 0.25s ease",
    "&:hover": {
      transform: "translateY(-4px)",
      boxShadow: "0 10px 24px rgba(0,0,0,0.22)",
    },
    "&:hover $image": { transform: "scale(1.06)" },
    "&:hover $overlay": { opacity: 1 },
  },
  // Ảnh để to: chiếm trọn chiều ngang masonry (span tất cả các cột)
  itemLarge: {
    columnSpan: "all",
    breakInside: "avoid",
  },
  // ----- Slider -----
  carousel: {
    position: "relative",
    display: "flex",
    alignItems: "center",
  },
  viewport: {
    overflow: "hidden",
    width: "100%",
  },
  track: {
    display: "flex",
    transition: "transform 0.4s ease",
  },
  slide: {
    boxSizing: "border-box",
    padding: 8,
    cursor: "pointer",
  },
  slideInner: {
    borderRadius: 12,
    overflow: "hidden",
    backgroundColor: "#fff",
    boxShadow: "0 4px 14px rgba(0,0,0,0.12)",
    transition: "transform 0.25s ease, box-shadow 0.25s ease",
    "&:hover": {
      transform: "translateY(-4px)",
      boxShadow: "0 10px 24px rgba(0,0,0,0.22)",
    },
  },
  slideImg: {
    width: "100%",
    objectFit: "cover",
    display: "block",
  },
  slideCaption: {
    padding: "8px 10px",
    color: "#37434d",
    textAlign: "center",
    display: "-webkit-box",
    WebkitLineClamp: 3,
    WebkitBoxOrient: "vertical",
    overflow: "hidden",
  },
  carouselBtn: {
    flex: "0 0 auto",
    color: "#fff",
    backgroundColor: "#ee6064",
    margin: "0 4px",
    "&:hover": { backgroundColor: "#d84f53" },
    "&.Mui-disabled": { backgroundColor: "#e0c3c4", color: "#fff" },
  },
  carouselPrev: {},
  carouselNext: {},
  image: {
    width: "100%",
    display: "block",
    transition: "transform 0.4s ease",
  },
  overlay: {
    position: "absolute",
    inset: 0,
    display: "flex",
    alignItems: "flex-end",
    justifyContent: "center",
    padding: 12,
    opacity: 0,
    background:
      "linear-gradient(to top, rgba(235,86,75,0.55) 0%, rgba(0,0,0,0) 55%)",
    transition: "opacity 0.25s ease",
  },
  zoomHint: {
    color: "#fff",
    fontWeight: 700,
    fontSize: 14,
    letterSpacing: 0.3,
    textShadow: "0 1px 4px rgba(0,0,0,0.5)",
  },
  lightboxPaper: {
    position: "relative",
    backgroundColor: "rgba(18,18,18,0.96)",
    overflow: "hidden",
    margin: 16,
  },
  lightboxContent: {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    justifyContent: "center",
  },
  // Khi click xem ảnh: cố gắng cho các ảnh cùng tỉ lệ (khung 3:2, cắt vừa khung)
  lightboxImage: {
    width: "min(90vw, 900px)",
    aspectRatio: "3 / 2",
    maxHeight: "80vh",
    objectFit: "cover",
    display: "block",
    backgroundColor: "#000",
  },
  lightboxFooter: {
    width: "100%",
    textAlign: "center",
    padding: "10px 48px",
    color: "#eee",
  },
  counter: { color: "#bdbdbd" },
  caption: { color: "#fff", marginTop: 2 },
  closeBtn: {
    position: "absolute",
    top: 6,
    right: 6,
    zIndex: 2,
    color: "#fff",
    backgroundColor: "rgba(0,0,0,0.35)",
    "&:hover": { backgroundColor: "rgba(0,0,0,0.6)" },
  },
  navBtn: {
    position: "absolute",
    top: "50%",
    transform: "translateY(-50%)",
    zIndex: 2,
    color: "#fff",
    backgroundColor: "rgba(0,0,0,0.35)",
    "&:hover": { backgroundColor: "rgba(0,0,0,0.6)" },
  },
  navPrev: { left: 8 },
  navNext: { right: 8 },
}));
